import { FeatureFlagIdIncreaseDefaultPageSize } from 'c1gen/features'
import { useFeatureChecker } from 'components/no-ui/capability'

const useGetDefaultPageSize = (): number => {
    const hasIncreaseDefaultPageSize = useFeatureChecker(FeatureFlagIdIncreaseDefaultPageSize)
    return hasIncreaseDefaultPageSize ? 100 : 50
}

export default useGetDefaultPageSize
